<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { TYPES as TASK_CATEGORY_TYPES } from './store'
import { ROUTES as TASK_CATEGORY_ROUTES } from './router'
import { hasPerm } from '@/components/PermissionHelper'

import ThuxListMixin from '../../../components/thux-list/ThuxListMixin'

import TaskCategoryTable from './TaskCategoryTable'
import TaskCategoryCommonFilters from './TaskCategoryCommonFilters'
import TaskCategoryEdit from './TaskCategoryEdit.vue'

export default {
  name: 'TaskCategoryList',
  mixins: [ThuxListMixin],
  components: {
    'component-table': TaskCategoryTable,
    'common-filters': TaskCategoryCommonFilters,
    'component-edit': TaskCategoryEdit,
    'component-detail': TaskCategoryEdit
  },
  data () {
    return {
      TASK_CATEGORY_ROUTES,
      title: this.$t('Categories'),
      rolePerm: ['tasks_taskcategory_list'],
      actionEnablePermission: ['tasks_taskcategory_enable'],
      actionDisablePermission: ['tasks_taskcategory_disable'],
      fieldName: 'code',
      searchFields: [
        { key: 'filter__code__icontains', placeholder: this.$t('Code'), type: 'text', col: 4 },
        { key: 'filter__name__icontains', placeholder: this.$t('Name'), type: 'text', col: 4 },
        { key: 'filter__type__name__icontains', placeholder: this.$t('Type'), type: 'text', col: 4 }
      ]
    }
  },
  computed: {
    ...mapGetters({
      ...TASK_CATEGORY_TYPES.GENERIC.task['task-category'].LIST.GETTERS
    }),
    showList () {
      return this.$route.name === this.TASK_CATEGORY_ROUTES.TASK_CATEGORY_LIST
    },
    canSeeActionSelect () {
      return true
    },
    canAddInstance () {
      return hasPerm('tasks_taskcategory_create')
    }
  },
  methods: {
    ...mapMutations({
      setSelectedList: TASK_CATEGORY_TYPES.GENERIC.task['task-category'].LIST.MUTATIONS.setSelectedList,
      setSelectAll: TASK_CATEGORY_TYPES.GENERIC.task['task-category'].LIST.MUTATIONS.setSelectAll
    }),
    ...mapActions({
      ...TASK_CATEGORY_TYPES.GENERIC.task['task-category'].LIST.ACTIONS
    })
  }
}
</script>
